import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";

export default function BusinessProfile() {
  const [form, setForm] = useState({ agency_name: "", pan_number: "", gst_number: "", business_address: "", business_proof_url: "" });
  const [busy, setBusy] = useState(false);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { (async () => { try { const { data } = await api.get("/business"); if (data) setForm({ ...form, ...data }); } catch {} setLoaded(true); })(); /* eslint-disable-line */ }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.put("/business", form); toast.success("Saved."); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  if (!loaded) return <div className="text-gray-500">Loading…</div>;
  const inputCls = "mt-1 w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500";

  return (
    <div className="max-w-2xl space-y-6" data-testid="business-page">
      <div>
        <h1 className="text-2xl font-bold font-display">Business Profile</h1>
        <p className="text-sm text-gray-500 mt-1">Used for billing and compliance only.</p>
      </div>
      <form onSubmit={save} className="card-base p-6 space-y-4">
        <div><label className="text-sm font-medium">Agency / firm name</label><input data-testid="biz-name" required value={form.agency_name} onChange={(e) => setForm({...form, agency_name: e.target.value})} className={inputCls} /></div>
        <div><label className="text-sm font-medium">PAN number</label><input data-testid="biz-pan" required value={form.pan_number} onChange={(e) => setForm({...form, pan_number: e.target.value})} placeholder="ABCDE1234F" className={inputCls} /></div>
        <div><label className="text-sm font-medium">GST number <span className="text-gray-400">(optional)</span></label><input value={form.gst_number || ""} onChange={(e) => setForm({...form, gst_number: e.target.value})} className={inputCls} /></div>
        <div><label className="text-sm font-medium">Business address</label><textarea required value={form.business_address} onChange={(e) => setForm({...form, business_address: e.target.value})} className={inputCls} rows={2} /></div>
        <button data-testid="biz-save" disabled={busy} className="bg-[#F97316] hover:bg-[#EA580C] btn-press text-white px-5 py-2.5 rounded-lg font-medium text-sm disabled:opacity-50">Save Business Details</button>
      </form>
    </div>
  );
}
